export const API_ERROR = "api_failed";
export const PURCHASE_INDENTS_LIST = "rfq_purchase_indents_list";
export const PURCHASE_INDENTS_LIST_SUCCESS =
  "rfq_purchase_indents_list_success";
export const PURCHASE_INDENTS_LIST_CHECKED =
  "rfq_purchase_indents_list_checked";
export const ALL_PURCHASE_INDENTS_LIST_CHECKED =
  "all_rfq_purchase_indents_list_checked";
export const RFQ_SELECTED_ITEM = "rfq_selected_item";
export const RFQ_SELECTED_ALL_VENDORS = "rfq_selected_all_vendors";
export const RFQ_SELECTED_VENDORS = "rfq_selected_vendors";
export const CELAR_VENDORS = "celar_vendors";
export const VENDORS_LIST = "rfq__vendors_list";
export const VENDORS_LIST_SUCCESS = "rfq_vendors_list_success";
export const GET_VENDORS_DATA = "get_vendors_data";
export const VENDORS_DATA_SUCCESS = "vendors_data_success";
export const REQUESTFORQUOTATION_ADD = "requestforquotation_add";
export const DOWNLOAD_RFQ_BUTTON = "RFQ_download_rfq_button";

export const RFQ_LIST = "reqestforquotation_list";
export const RFQ_LIST_SUCCESS = "reqestforquotation_list_success";
export const RFQ_LIST_COUNT = "reqestforquotation_list_count";
export const RFQ_LIST_COUNT_SUCCESS = "reqestforquotation_list_count_success";

export const TOGGLE_ITEM_MENU = "rfq_toggle_item_menu";

export const INPUT_CHANGEVALUE = "rfq_input_ChangeValue";
export const SELECT_CHANGEVALUE = "rfq_Select_ChangeValue";

export const SET_PARAMS = "rfq_set_params";
export const FILTER_INPUT_CHANGEVALUE = "rfq_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "rfq_Filter_Select_ChangeValue";

export const RFQ_ROW_DATA = "req_row_data";
export const RFQ_ROW_DATA_SUCCESS = "rfq_row_data_success";

export const RF_MODEL_LIST_OPEN = "rf_listItem_model_open";
export const RF_MODEL_LIST_CLOSE = "RF_listItem_model_close";
export const LIST_LAYOUT = "rfq_list_layout";

export const GENERATE_RFQ_PDF = "rfq_generate_pdf";

export const FILTERS_SHOW_RIGHT_SIDEBAR = "RFQ_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "RFQ_filter_hide_right_sidebar";
export const CLEAR_FILTER = "RFQ_clear_filter";

export const ADD_VENDORS = "rfq_add_vendors";
export const TOOLTI_OPEN = "rfq_tooltip_open";

export const PI_DETAILS_MODEL_OPEN = "RFQ_PI_details_model_open";
export const PI_DETAILS_MODEL_CLOSE = "RFQ_pi_details_model_close";
export const PI_ROW_DATA_SUCCESS = "RFQ_pi_row_data";

export const MR_CODE_DETAILS = "RFQ_mr_code_details";
export const MR_CODE_DETAILS_SUCCESS = "RFQ_mr_code_details_Successful";
export const ADD_VENDORS_MODEL_CLOSE = "RFQ_add_vendors_model_close";
export const ADD_VENDORS_MODEL_OPEN = "RFQ_add_vendors_model_open";
export const SET_MINI_VENDORS_LIST = "RFQ_set_mini_vendors_list";

export const MR_ITEM_IMAGES = "RFQ_mr_item_images";
export const MR_ITEM_IMAGES_SUCCESS = "RFQ_mr_item_images_Successful";
export const PI_MR_ITEM_IMAGES_MODEL_CLOSE = "RFQ_mr_item_images_model_close";

export const RFQ_PI_ITEM_CANCEL = "RFQ_PI_ITEM_cancel";
